import { render, staticRenderFns } from "./ReviewInventoryChips.vue?vue&type=template&id=7e0ad910"
import script from "./ReviewInventoryChips.vue?vue&type=script&lang=ts"
export * from "./ReviewInventoryChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports